module.exports = __webpack_public_path__ + "static/media/sarajeva_back.5b9b9fec.jpg";